module.exports = __webpack_public_path__ + "static/dire_corby-66e77f31b7c47e8041ea89bc5c2a74b6.jpeg";